var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9448 12.3314C21.9808 12.2268 22 12.1149 22 12C22 11.6327 21.8035 11.2967 21.4916 11.1257C21.4779 11.1181 21.4639 11.1109 21.4498 11.1041L3.37143 2.09799C3.01809 1.92196 2.59669 1.98695 2.30831 2.26193C2.01993 2.53691 1.92301 2.96617 2.06379 3.34488L5.28118 12L2.06379 20.6551C1.92301 21.0338 2.01993 21.4631 2.30831 21.7381C2.59669 22.0131 3.01809 22.078 3.37143 21.902L21.4417 12.9C21.4839 12.8799 21.5245 12.8568 21.5631 12.8309C21.7415 12.7115 21.8748 12.535 21.9448 12.3314ZM16.8524 11.0105L4.71526 4.96413L6.96288 11.0105H16.8524ZM16.8521 12.9897H6.96283L4.71526 19.0359L16.8521 12.9897Z",
    fill: "#444F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitArrowIcon);
export default __webpack_public_path__ + "static/media/submitArrowIcon.3c6c61dbc7b262c1e664db1848315b16.svg";
export { ForwardRef as ReactComponent };